var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Section from 'pxc-editor-core/entities/Section';
import { getAllLayers, getSelectedSections, getSortedSectionsArray, } from 'pxc-editor-core/helpers/schema';
import { createNewPage, getShieldsByGroupId } from '@/helpers';
import { overridePagesAction } from '@/actions/page';
import { createSnapshotThunk } from '@/actions';
export var fillSectionsFromExcelThunk = function (payload) { return function (dispatch, getState) {
    var labelsList = payload.labelsList;
    var content = labelsList.map(function (item) { return item.text; });
    var styles = labelsList.map(function (item) { return item.style; });
    var contentQueue = __spreadArray([], __read(content), false);
    var stylesQueue = __spreadArray([], __read(styles), false);
    if (!content.length) {
        return;
    }
    var _a = getState().core, pages = _a.pages, pagesOrder = _a.pagesOrder, pagesSelection = _a.pagesSelection, sectionsSelection = _a.sectionsSelection;
    var _b = __read(pagesSelection, 1), currentPageUid = _b[0];
    var currentPageIndex = pagesOrder.findIndex(function (uid) { return uid === currentPageUid; });
    var currentPage = pages[currentPageUid];
    var selectedSections = getSortedSectionsArray(getSelectedSections({
        sectionsSelection: sectionsSelection,
        page: currentPage,
    }));
    var _c = __read(selectedSections, 1), selectedSection = _c[0];
    var selectedSectionContentSettings = Section.getContentSettings(selectedSection);
    var layers = getAllLayers(selectedSection.id, pages);
    if (!layers.group)
        return;
    if (!layers.shield)
        return;
    var groupId = layers.group.id;
    var curShieldId = layers.shield.id;
    var modified = {
        pages: {},
        pagesOrder: [],
        pageIndex: currentPageIndex,
        shieldsSelection: {},
        sectionsSelection: {},
    };
    var _loop_1 = function () {
        var nextPageUid = pagesOrder[modified.pageIndex];
        var nextPage = !!nextPageUid ? pages[nextPageUid] : createNewPage();
        var nextPageGroupShields = Object.values(getShieldsByGroupId({ id: groupId, page: nextPage }));
        var curShieldIndex = nextPageGroupShields.findIndex(function (shield) { return shield.id === curShieldId; });
        var nextShields = curShieldIndex === -1
            ? nextPageGroupShields
            : nextPageGroupShields.slice(curShieldIndex);
        var nextShieldSections = nextShields.reduce(function (acc1, shield) {
            var nextShieldSectionsDict = Object.values(nextPage.sections).reduce(function (acc2, section) {
                var _a;
                if (shield.id === section.shieldId) {
                    return __assign(__assign({}, acc2), (_a = {}, _a[section.id] = section, _a));
                }
                return acc2;
            }, {});
            var nextShieldSections = getSortedSectionsArray(nextShieldSectionsDict);
            var curSectionIndex = nextShieldSections.findIndex(function (section) { return section.id === selectedSection.id; });
            var nextSections = curSectionIndex === -1
                ? nextShieldSections
                : nextShieldSections.slice(curSectionIndex);
            var updatedSections = nextSections.reduce(function (acc3, section) {
                var _a, _b, _c;
                var value = contentQueue.shift();
                var style = stylesQueue.shift();
                if (value) {
                    var item = __assign(__assign(__assign(__assign({}, section), style), selectedSectionContentSettings), { text: value });
                    modified.shieldsSelection = (_a = {}, _a[shield.id] = shield, _a);
                    modified.sectionsSelection = (_b = {}, _b[section.id] = item, _b);
                    return __assign(__assign({}, acc3), (_c = {}, _c[section.id] = item, _c));
                }
                return acc3;
            }, {});
            return __assign(__assign({}, acc1), updatedSections);
        }, {});
        modified.pages[nextPage.uid] = __assign(__assign({}, nextPage), { sections: __assign(__assign({}, nextPage.sections), nextShieldSections) });
        modified.pagesOrder.push(nextPage.uid);
        modified.pageIndex++;
    };
    while (!!contentQueue.length) {
        _loop_1();
    }
    var updatedPagesOrder = pagesOrder.reduce(function (acc, pageUid) {
        if (acc.includes(pageUid)) {
            return acc;
        }
        else if (pageUid === currentPageUid) {
            return __spreadArray(__spreadArray([], __read(acc), false), __read(modified.pagesOrder), false);
        }
        return __spreadArray(__spreadArray([], __read(acc), false), [pageUid], false);
    }, []);
    var _d = __read(modified.pagesOrder.reverse(), 1), lastUpdatedPageUid = _d[0];
    var updatedPaginationPageNum = updatedPagesOrder.findIndex(function (uid) { return uid === lastUpdatedPageUid; }) + 1;
    var updatedPagesSelection = [lastUpdatedPageUid];
    dispatch(createSnapshotThunk());
    dispatch(overridePagesAction({
        pages: __assign(__assign({}, pages), modified.pages),
        pagesOrder: updatedPagesOrder,
        shieldsSelection: modified.shieldsSelection,
        sectionsSelection: modified.sectionsSelection,
        paginationPageNum: updatedPaginationPageNum,
        pagesSelection: updatedPagesSelection,
    }));
}; };
